export const encodeId = (value) => {
  if (value === null || value === undefined) return null;
  return btoa(String(value));
};

export const decodeId = (value) => {
  if (!value) return null;           // ✅ guard

  try {
    return atob(value);              // ✅ return decoded value
  } catch (err) {
    return null;                     // ✅ invalid base64
  }
};
